import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

import Login from '../features/auth/login';

// FAANG-CLEANUP: Removed antiquated W11 harness logic
// The W11 smoke test harness was interfering with production login functionality

export default function LoginPage() {
  const router = useRouter();
  useEffect(() => {
    // Clear localStorage if user was logged out
    if (router.query.logged_out === '1') {
      try {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('subdomain');
        localStorage.removeItem('tenantId');

        // Clear common cookies
        document.cookie = 'token=; Max-Age=0; path=/';
        document.cookie = 'authToken=; Max-Age=0; path=/';
        document.cookie = 'jwt=; Max-Age=0; path=/';

        console.log('[LOGIN] Cleared auth state after logout');
      } catch (error) {
        console.error('[LOGIN] Error clearing auth state:', error);
      }
    }
  }, [router]);
  return <Login />;
}

// Login page is now client-side only to avoid SSR data file issues
